import { SvgIconComponent } from "@mui/icons-material";
import SchoolIcon from "@mui/icons-material/School";
import PersonIcon from "@mui/icons-material/Person";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import BusinessIcon from "@mui/icons-material/Business";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import AssessmentIcon from "@mui/icons-material/Assessment";
import DateRangeIcon from "@mui/icons-material/DateRange";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import MoveUpIcon from "@mui/icons-material/MoveUp";
import ScheduleIcon from "@mui/icons-material/Schedule";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import InventoryIcon from "@mui/icons-material/Inventory";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import CampaignIcon from "@mui/icons-material/Campaign";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PaymentIcon from "@mui/icons-material/Payment";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import SmsIcon from "@mui/icons-material/Sms";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import EmailIcon from "@mui/icons-material/Email";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";

import {
  SIDEBAR_ITEMS,
  SidebarItem,
  SidebarEntry,
} from "../config/sidebarConfig";
import { ENTITY_TO_ROUTE_MAP } from "../config/trackingConfig";

export interface EntityMeta {
  icon: SvgIconComponent;
  color: string;
  title: string;
}

export const ENTITY_META: Record<string, EntityMeta> = {
  TEACHER: { icon: PersonIcon, color: "#1976d2", title: "Teachers" },
  STUDENT: { icon: SchoolIcon, color: "#9c27b0", title: "Students" },
  CLASSROOM: { icon: MeetingRoomIcon, color: "#ed6c02", title: "Classrooms" },
  USER: {
    icon: AdminPanelSettingsIcon,
    color: "#d32f2f",
    title: "System Users",
  },
  BRANCH: { icon: BusinessIcon, color: "#607d8b", title: "Branches" },
  PARENT_GUARDIAN: {
    icon: FamilyRestroomIcon,
    color: "#2e7d32",
    title: "Parents",
  },
  SUBJECT: { icon: MenuBookIcon, color: "#009688", title: "Subjects" },
  ENROLLMENT: { icon: PeopleAltIcon, color: "#0288d1", title: "Enrollments" },
  STUDENT_FEE_LEDGER: {
    icon: AccountBalanceWalletIcon,
    color: "#1b5e20",
    title: "Fee Collections",
  },
  ATTENDANCE_RECORD: {
    icon: FactCheckIcon,
    color: "#fb8c00",
    title: "Daily Attendance",
  },
  REPORT_CARD: {
    icon: TrendingUpIcon,
    color: "#673ab7",
    title: "Academic Performance",
  },
  FEE_STRUCTURE: {
    icon: AccountBalanceWalletIcon,
    color: "#fbc02d",
    title: "Fee Structures",
  },
  ASSESSMENT: {
    icon: AssessmentIcon,
    color: "#673ab7",
    title: "Academic Performance",
  },
  ACADEMIC_YEAR: {
    icon: DateRangeIcon,
    color: "#512da8",
    title: "Academic Years",
  },
  TIMETABLE: { icon: CalendarMonthIcon, color: "#c2185b", title: "Timetables" },
  CURRICULUM_REQUIREMENT: {
    icon: AssignmentTurnedInIcon,
    color: "#00796b",
    title: "Curriculum Fulfillment",
  },
  VOTE_HEAD: {
    icon: RequestQuoteIcon,
    color: "#827717",
    title: "Fee Vote Heads",
  },
  TRANSITION_RECORD: {
    icon: MoveUpIcon,
    color: "#00838f",
    title: "Student Transitions",
  },
  TIMESLOT: {
    icon: ScheduleIcon,
    color: "#00bcd4",
    title: "Defined Timeslots",
  },
  TIMETABLE_SLOT: {
    icon: EventAvailableIcon,
    color: "#6d4c41",
    title: "Scheduled Lessons",
  },
  INVENTORY_ITEM: {
    icon: InventoryIcon,
    color: "#d84315",
    title: "Inventory Status",
  },
  SUPPLIER: { icon: LocalShippingIcon, color: "#455a64", title: "Suppliers" },
  ANNOUNCEMENT: {
    icon: CampaignIcon,
    color: "#e91e63",
    title: "Announcements",
  },
  NOTIFICATION: {
    icon: NotificationsActiveIcon,
    color: "#ff9800",
    title: "Notifications",
  },
  SMS_OUTBOX: {
    icon: SmsIcon,
    color: "#3f51b5",
    title: "SMS Outbox & Delivery",
  },
  SMS_TEMPLATE: {
    icon: TextSnippetIcon,
    color: "#795548",
    title: "SMS Templates",
  },
  INVOICE: {
    icon: ReceiptLongIcon,
    color: "#d32f2f",
    title: "Supplier Invoices",
  },
  PURCHASE_ORDER: {
    icon: ShoppingCartIcon,
    color: "#1976d2",
    title: "Purchase Orders",
  },
  PAYMENT: {
    icon: PaymentIcon,
    color: "#2e7d32",
    title: "Supplier Payments",
  },
  STUDENT_TERM_REPORT: {
    icon: HistoryEduIcon,
    color: "#4caf50",
    title: "Term Reports & Grades",
  },
  NEWSLETTER: { icon: EmailIcon, color: "#ff5722", title: "Newsletters" },
  BANK_TRANSACTION_STAGING: {
    icon: AccountBalanceIcon,
    color: "#f57c00",
    title: "Bank Reconciliations",
  },
  AUDIT_LOG: {
    icon: ManageHistoryIcon,
    color: "#607d8b",
    title: "System Audit & Activity",
  },
  DEFAULT: { icon: MenuBookIcon, color: "#757575", title: "Module" },
};

export const getEntityMeta = (entityKey: string): EntityMeta => {
  return ENTITY_META[entityKey] || { ...ENTITY_META.DEFAULT, title: entityKey };
};

const isSidebarItem = (entry: SidebarEntry): entry is SidebarItem => {
  return !("isHeader" in entry);
};

export const getSidebarItemByEntity = (
  entityKey: string,
): SidebarItem | null => {
  const route = ENTITY_TO_ROUTE_MAP[entityKey];
  if (!route) return null;
  return (
    SIDEBAR_ITEMS.filter(isSidebarItem).find((item) => item.path === route) ||
    null
  );
};
